/* eslint-disable */
import * as React from "react";
import { last, first } from "lodash";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer, useParameter, yearToCropYearShort, useDictionaryItem } from "../../shared";
import { CalendarControl } from "./controls/CalendarControl";
import { CalendarControl2 } from "./controls/CalendarControl2";
import { CommoditiesControl } from "./controls/CommoditiesControl";
import { BusinessUnitControl } from "./controls/BusinessUnitControl";
import { useExportQuery } from "./export/useExportQuery";
import { useFavourite } from "./favourite/useFavourite";
import { useSubscription } from "./subscription/useSubscription";
import { dictionaryService } from "../../dataFlow";

export default function (props: { exportMode?: boolean }) {
  const { exportMode } = props;
  const description = [
    "Showing Stock to use-ratio vs. price Index for soybean, rice, wheat and corn",
    "Stock-use-ratio - Percentage of domestic consumption which can be covered by stocks (Ending stocks /Domestic consumption (in %))",
    "The basis year for the Index calculation can be selected",
    "On the right side the long-term mega-trends as seen by Crop Life are mentioned",
    "Source: USDA, ICE, NYSE (Commodity Prices), USDA PS&D, USDA Projections (Ending Stocks), Crop Life (Trends)",
  ];
  const [parameterValues] = useParameter<number[]>("@calendar");
  const [, calendarStartName] = useDictionaryItem(dictionaryService, "slides-calendar", first(parameterValues));
  const [, calendarEndName] = useDictionaryItem(dictionaryService, "slides-calendar", last(parameterValues));
  const yearStart = calendarStartName ? Number(calendarStartName) : new Date().getFullYear() - 1;
  const yearEnd = calendarEndName ? Number(calendarEndName) : new Date().getFullYear() - 1;
  const subtitle = `${yearStart} - ${yearEnd}`;
  const title = "Stocks to use-ratio vs crop price index";

  useExportQuery(title, subtitle);
  useFavourite();
  useSubscription();

  return (
    <ReportContainer>
      <ReportHeader title={title} subtitle={subtitle} description={description} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup>
          {/* <BusinessUnitControl />
            <CommoditiesControl /> */}
          <CalendarControl />
          <CalendarControl2 />
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={14} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid>
          <ReportRenderer componentId="chart-area-production-yield" />
          <ReportRenderer componentId="chart-area-production-yield2" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
}
